/* global angular, emergence */

(function () {
    "use strict";

    var app = angular.module('app');

    app.directive('appear', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                scope.$on('onScrollbarDidChange', function ($scope, e) {
                    var rect = {
                        x: element[0].offsetLeft,
                        y: element[0].offsetTop,
                        width: element[0].offsetWidth,
                        height: element[0].offsetHeight,
                    }
                    // console.log('appear.onScrollbarDidChange', e, rect);
                });
            }
        };
    }]);

}());